import { useEffect } from 'react';
import { coreFromSettings, deriveAllCssVars } from '../theme/config';
// Applies a community's colors to :root while mounted with settings and restores the host's on cleanup.
export const useCommunityTheme = (settings) => {
    useEffect(() => {
        if (!settings)
            return undefined;
        const root = document.documentElement;
        const vars = deriveAllCssVars(coreFromSettings(settings));
        const previous = Object.keys(vars).map(key => ({
            key,
            value: root.style.getPropertyValue(key),
            priority: root.style.getPropertyPriority(key),
        }));
        Object.entries(vars).forEach(([key, value]) => root.style.setProperty(key, value));
        return () => {
            previous.forEach(p => {
                if (p.value)
                    root.style.setProperty(p.key, p.value, p.priority);
                else
                    root.style.removeProperty(p.key);
            });
        };
    }, [settings]);
};
export default useCommunityTheme;
